var _style, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVobbizGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1190.6 330",
    style: {
      enableBackground: "new 0 0 1190.6 330"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000121254538807310797670000001384734300398856106_);}\n\t.st2{fill:url(#SVGID_00000114772333057355510460000010853292093156546961_);}\n\t.st3{fill:url(#SVGID_00000168813230966889971850000009535048368641648020_);}\n\t.st4{fill:url(#SVGID_00000093137567868342855330000012944011505006198925_);}\n\t.st5{fill:url(#SVGID_00000131352092593529101670000005567591245768422844_);}\n\t.st6{fill:url(#SVGID_00000120516777735920309180000001618415005726792125_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.1814,
    y1: 181.7866,
    x2: 1088.0924,
    y2: 181.7866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03825822,
    style: {
      stopColor: "#F8ABEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    style: {
      stopColor: "#C5ADED"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "474.5,118.7 510,118.7 464.4,244.8 429.7,244.8 384.4,118.7 421.4,118.7 447.7,211.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075154548635204955550000000813437327843321275_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.1814,
    y1: 183.8599,
    x2: 1088.0924,
    y2: 183.8599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03825822,
    style: {
      stopColor: "#F8ABEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    style: {
      stopColor: "#C5ADED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075154548635204955550000000813437327843321275_)"
    },
    d: "M624.9,229.9c-10.3,12.7-26,19.1-47,19.1 c-21,0-36.7-6.4-47-19.1c-10.3-12.7-15.5-28.1-15.5-46c0-17.6,5.2-32.9,15.5-45.8c10.3-12.9,26-19.4,47-19.4 c21,0,36.7,6.5,47,19.4c10.3,12.9,15.5,28.2,15.5,45.8C640.4,201.8,635.2,217.2,624.9,229.9 M599.3,212.2c5-6.6,7.5-16.1,7.5-28.3 c0-12.2-2.5-21.7-7.5-28.3c-5-6.6-12.2-9.9-21.5-9.9c-9.3,0-16.5,3.3-21.6,9.9c-5,6.6-7.6,16-7.6,28.3c0,12.2,2.5,21.7,7.6,28.3 c5,6.6,12.2,10,21.6,10C587.2,222.2,594.3,218.9,599.3,212.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168076076471728596210000010969338532262162329_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.1814,
    y1: 163.9633,
    x2: 1088.0924,
    y2: 163.9633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03825822,
    style: {
      stopColor: "#F8ABEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    style: {
      stopColor: "#C5ADED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168076076471728596210000010969338532262162329_)"
    },
    d: "M767.6,137.3 c-9.1-11.6-21.8-17.4-38-17.4c-9,0-16.3,1.9-22.1,5.6c-4.9,3-9.4,7.3-13.4,13V79.8h-31.9v168.2H730c0.4,0,0.7,0,1.1,0 c15.6-0.3,27.9-6.5,36.7-18.7c9-12.5,13.5-28.2,13.5-47.2C781.3,163.9,776.7,148.9,767.6,137.3 M740.9,211.8 c-4.6,6.7-11,10-19.3,10c-9.6,0-16.7-3.4-21.4-10.3c-4.7-6.9-7-15.5-7-26c0-8.9,1.1-16.1,3.4-21.7c4.4-10.5,12.4-15.8,24.1-15.8 c11.5,0,19.4,5.4,23.7,16.1c2.3,5.7,3.4,12.9,3.4,21.5C747.8,196.4,745.5,205.1,740.9,211.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143595093301196163400000015099443548350346141_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.1814,
    y1: 163.9633,
    x2: 1088.0924,
    y2: 163.9633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03825822,
    style: {
      stopColor: "#F8ABEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    style: {
      stopColor: "#C5ADED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143595093301196163400000015099443548350346141_)"
    },
    d: "M907.8,137.3 c-9.1-11.6-21.8-17.4-38-17.4c-8.9,0-16.3,1.9-22.1,5.6c-4.9,3-9.4,7.3-13.4,13V79.8h-31.9v168.2h67.9c0.4,0,0.7,0,1.1,0 c15.6-0.3,27.9-6.5,36.7-18.7c9-12.5,13.5-28.2,13.5-47.2C921.5,163.9,916.9,148.9,907.8,137.3 M881.1,211.8 c-4.6,6.7-11,10-19.3,10c-9.6,0-16.7-3.4-21.4-10.3c-4.7-6.9-7-15.5-7-26c0-8.9,1.1-16.1,3.4-21.7c4.4-10.5,12.4-15.8,24.1-15.8 c11.5,0,19.4,5.4,23.7,16.1c2.3,5.7,3.4,12.9,3.4,21.5C888,196.4,885.7,205.1,881.1,211.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125602358843477014550000008109844340182907581_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.1814,
    y1: 161.722,
    x2: 1088.0924,
    y2: 161.722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03825822,
    style: {
      stopColor: "#F8ABEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    style: {
      stopColor: "#C5ADED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125602358843477014550000008109844340182907581_)"
    },
    d: "M976.5,108.1h-32.4V78.6h32.4V108.1z  M944.1,122.7h32.4v122.2h-32.4V122.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111187685555795342550000018436519282254409357_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.1814,
    y1: 183.7475,
    x2: 1088.0924,
    y2: 183.7475
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03825822,
    style: {
      stopColor: "#F8ABEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    style: {
      stopColor: "#C5ADED"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111187685555795342550000018436519282254409357_)"
    },
    points: "1000.5,148.7 1000.5,122.7  1097.1,122.7 1097.1,149.2 1037.2,218.6 1099.3,218.6 1099.3,244.8 996.3,244.8 996.3,220 1056.8,148.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128457877538740386620000015434927446671753125_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.1814,
    y1: 163.7955,
    x2: 1088.0924,
    y2: 163.7955
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03825822,
    style: {
      stopColor: "#F8ABEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    style: {
      stopColor: "#C5ADED"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128457877538740386620000015434927446671753125_)"
    },
    d: "M218.7,47.4 c-64.3,0-116.4,52.1-116.4,116.4s52.1,116.4,116.4,116.4S335,228.1,335,163.8S282.9,47.4,218.7,47.4z M295.7,125.9l-72.8,124.9 c-1.9,3.3-6.6,3.3-8.5,0l-72.8-124.9c-1.9-3.3,0.5-7.4,4.3-7.4l81.2,0c4.6,0,8.3,3.7,8.3,8.3l0,33.6c0,2.7,3.6,3.7,5,1.3l21.6-37.2 c2.2-3.8,6.3-6.1,10.7-6.1h18.8C295.3,118.4,297.6,122.6,295.7,125.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVobbizGradient);
export default __webpack_public_path__ + "static/media/VobbizGradient.c31c3ceb5ac3b70c3a9cbdff86f7d208.svg";
export { ForwardRef as ReactComponent };